/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react"
import { WrapRootElement } from "./src/wrap-root-element"

export const wrapRootElement = ({ element }) => {
	return <WrapRootElement element={element} />
}
